const sectors = [
  "Financial Services",
  "Lending & Mortgage",
  "Insurance",
  "Real Estate",
  "Capital Markets",
  "Fintech Platforms",
];

export default function TrustBar() {
  return (
    <section id="trust" className="bg-white border-b border-bfx-border overflow-hidden">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-10">
        <div className="flex flex-col md:flex-row items-center gap-6 md:gap-12">
          {/* Label */}
          <p className="text-[11px] font-semibold text-bfx-muted tracking-[0.14em] uppercase whitespace-nowrap shrink-0">
            Built for operators in
          </p>

          {/* Vertical rule */}
          <div className="hidden md:block w-px h-5 bg-bfx-border shrink-0" />

          {/* Sectors */}
          <div className="flex flex-wrap items-center justify-center md:justify-start gap-x-8 gap-y-3 flex-1">
            {sectors.map((s, i) => (
              <div key={s} className="flex items-center gap-5">
                <span className="text-sm font-medium text-bfx-primary/70 whitespace-nowrap">
                  {s}
                </span>
                {i < sectors.length - 1 && (
                  <span className="hidden sm:block w-1 h-1 rounded-full bg-bfx-border shrink-0" />
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}